import "./embedded-video-block.scss";